export const HOME_SLICE_NAME = "home"

export const HOME_CHART = {
  PREVENTED: "prevented",
  DEFLECTED: "deflected",
  RATE: "rate"
}
